import type { FirebaseContextType } from '@/providers/firebase/Firebase.provider'

/**
 * @private This type is only to use in the AppStatusBadge component
 */
export type Features = Pick<
  FirebaseContextType,
  'flashSalesAreEnabled' | 'giveawaysAreEnabled' | 'shipmentsAreEnabled' | 'auctionAreEnabled'
>

/**
 * @private This component is only to use in the AppStatusBadge component
 */
export const getFeatureDisabled = (features: Features) => {
  return Object.keys(features).reduce<string[]>((acc, key) => {
    const _key = key as keyof Features
    const isEnabled = features[_key]
    if (!isEnabled) {
      acc.push(mapFeatures(_key))
    }
    return acc
  }, [])
}

const mapFeatures = (feature: keyof Features): string => {
  switch (feature) {
    case 'flashSalesAreEnabled':
      return 'flashSale'
    case 'giveawaysAreEnabled':
      return 'giveaway'
    case 'shipmentsAreEnabled':
      return 'shipment'
    case 'auctionAreEnabled':
      return 'auction'
    default:
      return ''
  }
}
